//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from "vuex-pathify"

export default {
  data() {
    const { respuestas, ...pregunta } = this.$store.copy("examen/pregunta/seleccion")
    return {
      pregunta,
      respuestas,
    }
  },

  computed: {
    examen: get("examen/seleccion"),
    pregunta_completa() {
      return {
        respuestas: this.respuestas,
        ...this.pregunta,
      }
    },
  },

  methods: {
    async submit() {
      await this.$store.dispatch("examen/pregunta/update", {
        examen: this.examen.id,
        pregunta: this.pregunta_completa,
      })
      this.$emit("submit", this.pregunta_completa)
    },

    addRespuesta() {
      this.respuestas.push({})
    },

    setRespuestaCorrecta(respuesta, index) {
      this.respuestas = this.respuestas.map((e) => {
        e.es_correcta = false

        return e
      })
      this.respuestas[index].es_correcta = true
    },

    removeRespuesta(respuesta, index) {
      this.respuestas = this.respuestas.filter((e, i) => i != index)
    },
  },
}
